import { apiClient } from './client'

// Types
export interface ProtrackCredentialsStatus {
  configured: boolean
  status: 'ACTIVE' | 'INACTIVE' | 'EXPIRED' | 'ERROR' | null
  isActive: boolean
  lastVerifiedAt: string | null
  lastErrorMessage: string | null
}

export interface ProtrackCredentials {
  id: string
  institutionId: string
  status: 'ACTIVE' | 'INACTIVE' | 'EXPIRED' | 'ERROR'
  isActive: boolean
  lastVerifiedAt?: string
  lastErrorMessage?: string
  createdBy?: {
    firstName: string
    lastName: string
    email: string
  }
  updatedBy?: {
    firstName: string
    lastName: string
    email: string
  }
  notes?: string
  createdAt: string
  updatedAt: string
  hasCredentials: boolean
}

export interface UpsertProtrackCredentialsRequest {
  account: string
  password: string
  notes?: string
}

// API response types
interface ApiResponse<T> {
  success: boolean
  data: T
  message: string
}

/**
 * Get Protrack credentials status (lightweight check)
 */
export const getProtrackCredentialsStatus = async (): Promise<ProtrackCredentialsStatus> => {
  const response = await apiClient.get<ApiResponse<ProtrackCredentialsStatus>>('/protrack-credentials/status')
  return response.data.data
}

/**
 * Get Protrack credentials for the current institution
 */
export const getProtrackCredentials = async (): Promise<ProtrackCredentials | null> => {
  const response = await apiClient.get<ApiResponse<ProtrackCredentials | null>>('/protrack-credentials')
  return response.data.data
}

/**
 * Create or update Protrack credentials
 */
export const upsertProtrackCredentials = async (
  data: UpsertProtrackCredentialsRequest
): Promise<ProtrackCredentials> => {
  const response = await apiClient.post<ApiResponse<ProtrackCredentials>>('/protrack-credentials', data)
  return response.data.data
}

/**
 * Verify Protrack credentials with Protrack API
 */
export const verifyProtrackCredentials = async (): Promise<ProtrackCredentials> => {
  const response = await apiClient.post<ApiResponse<ProtrackCredentials>>('/protrack-credentials/verify')
  return response.data.data
}

/**
 * Delete Protrack credentials
 */
export const deleteProtrackCredentials = async (): Promise<void> => {
  await apiClient.delete('/protrack-credentials')
}
